export default function ValueProposition() {
  const values = [
    {
      icon: 'ri-truck-line',
      iconBg: 'bg-orange-600',
      title: 'Fast Pickup',
      description: 'Most vehicles picked up within 1-3 business days from booking'
    },
    {
      icon: 'ri-shield-check-line',
      iconBg: 'bg-gray-900',
      title: 'Fully Insured',
      description: 'Every shipment covered up to $1M with comprehensive carrier insurance'
    },
    {
      icon: 'ri-money-dollar-circle-line',
      iconBg: 'bg-orange-600',
      title: 'Best Rates',
      description: 'Compare quotes from 500+ carriers to find the most competitive pricing'
    }
  ];

  return (
    <section className="py-24 bg-gradient-to-b from-orange-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-5xl font-bold text-gray-900 text-center mb-16">
          Why Choose Our Service
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {values.map((value, index) => (
            <div
              key={index}
              className="text-center group hover:transform hover:scale-105 transition-all duration-300"
            >
              <div className={`w-20 h-20 ${value.iconBg} rounded-full flex items-center justify-center mx-auto mb-6 group-hover:shadow-xl transition-shadow`}>
                <i className={`${value.icon} text-4xl text-white`}></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                {value.title}
              </h3>
              <p className="text-lg text-gray-600 leading-relaxed">
                {value.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
